/* global google, InfoBox */
import { loadScript, iconSVG, getOption } from '../tools/utils';
import 'whatwg-fetch';


export const init = () => {
	const BASE_PATH = getOption('basePath');
	const elements = [...document.querySelectorAll('.b-gmap__holder')];

	if (!elements.length) return;

	//const API_KEY_OLD = 'AIzaSyDGlupN-YLw9J-0eBQRohCUMMlRh4Jf5TQ'; // stary key
	//const API_KEY = 'AIzaSyA3eq_sxlvl39g3teYR_ivDNqCHhjPu2RA'; // novy key
	const API_KEY = 'AIzaSyCETRruLX_CqAbe0wW9HRq91ocvQVfM6VM'; // nejnovejsi key
	const INFOBOX_URL = `${BASE_PATH}js/infobox.js`;
	const SCRIPT_URL = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}`;

	const getMarkersData = (element) => {
		const url = element.getAttribute('data-markers');

		if (url) return fetch(url);

		return false;
	};

	const getCoordinatesData = (element) => {
		const data = element.getAttribute('data-coordinates');
		const coordinates = data && data.split(',');

		if (coordinates && coordinates.length === 2) return {
			lat: parseFloat(coordinates[0]),
			lng: parseFloat(coordinates[1]),
		};

		return false;
	};

	const initMap = (element) => {
		const coordinates = getCoordinatesData(element);
		const markers = getMarkersData(element);

		if (coordinates) {
			createMap(element, coordinates);
		} else if (markers) {
			markers
				.then((response) => {
					if (response.ok) {
						return response.json();
					}
				})
				.then((markers) => {
					loadScript(INFOBOX_URL, () => createMapWithMarkers(element, markers));
				});
		}
	};

	const createMap = (element, coordinates) => {
		const zoom = parseInt(element.getAttribute('data-zoom')) || 17;

		const map = new google.maps.Map(element, {
			zoom: zoom,
			center: coordinates,
			disableDefaultUI: true,
		});

		new google.maps.Marker({
			position: coordinates,
			map: map,
		});
	};

	const createMapWithMarkers = (element, markers) => {
		const MARKER_SQUARE = {
			size: new google.maps.Size(36, 41),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(18, 41),
		};
		const MARKER_ROUND = {
			size: new google.maps.Size(40, 48),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(20, 48),
		};
		const MARKER_TYPES = [
			{
				url: `${BASE_PATH}img/bg/markers/vut.svg`,
				size: MARKER_SQUARE.size,
				origin: MARKER_SQUARE.origin,
				anchor: MARKER_SQUARE.anchor,
			},
			{
				url: `${BASE_PATH}img/bg/markers/fa.svg`,
				size: MARKER_SQUARE.size,
				origin: MARKER_SQUARE.origin,
				anchor: MARKER_SQUARE.anchor,
			},
			{
				url: `${BASE_PATH}img/bg/markers/fekt.svg`,
				size: MARKER_SQUARE.size,
				origin: MARKER_SQUARE.origin,
				anchor: MARKER_SQUARE.anchor,
			},
			{
				url: `${BASE_PATH}img/bg/markers/fch.svg`,
				size: MARKER_SQUARE.size,
				origin: MARKER_SQUARE.origin,
				anchor: MARKER_SQUARE.anchor,
			},
			{
				url: `${BASE_PATH}img/bg/markers/fit.svg`,
				size: MARKER_SQUARE.size,
				origin: MARKER_SQUARE.origin,
				anchor: MARKER_SQUARE.anchor,
			},
			{
				url: `${BASE_PATH}img/bg/markers/fast.svg`,
				size: MARKER_SQUARE.size,
				origin: MARKER_SQUARE.origin,
				anchor: MARKER_SQUARE.anchor,
			},
			{
				url: `${BASE_PATH}img/bg/markers/fp.svg`,
				size: MARKER_SQUARE.size,
				origin: MARKER_SQUARE.origin,
				anchor: MARKER_SQUARE.anchor,
			},
			{
				url: `${BASE_PATH}img/bg/markers/fsi.svg`,
				size: MARKER_SQUARE.size,
				origin: MARKER_SQUARE.origin,
				anchor: MARKER_SQUARE.anchor,
			},
			{
				url: `${BASE_PATH}img/bg/markers/favu.svg`,
				size: MARKER_SQUARE.size,
				origin: MARKER_SQUARE.origin,
				anchor: MARKER_SQUARE.anchor,
			},
			{
				url: `${BASE_PATH}img/bg/markers/usi.svg`,
				size: MARKER_SQUARE.size,
				origin: MARKER_SQUARE.origin,
				anchor: MARKER_SQUARE.anchor,
			},
			{
				url: `${BASE_PATH}img/bg/markers/sti.svg`,
				size: MARKER_SQUARE.size,
				origin: MARKER_SQUARE.origin,
				anchor: MARKER_SQUARE.anchor,
			},
			{
				url: `${BASE_PATH}img/bg/markers/cesa.svg`,
				size: MARKER_SQUARE.size,
				origin: MARKER_SQUARE.origin,
				anchor: MARKER_SQUARE.anchor,
			},
			{
				url: `${BASE_PATH}img/bg/markers/sport.svg`,
				size: MARKER_ROUND.size,
				origin: MARKER_ROUND.origin,
				anchor: MARKER_ROUND.anchor,
			},
			{
				url: `${BASE_PATH}img/bg/markers/cafeteria.svg`,
				size: MARKER_ROUND.size,
				origin: MARKER_ROUND.origin,
				anchor: MARKER_ROUND.anchor,
			},
			{
				url: `${BASE_PATH}img/bg/markers/dormitory.svg`,
				size: MARKER_ROUND.size,
				origin: MARKER_ROUND.origin,
				anchor: MARKER_ROUND.anchor,
			},
		];

		const center = new google.maps.LatLng(markers[0].location[0], markers[0].location[1]);
		const bounds = new google.maps.LatLngBounds();
		const map = new google.maps.Map(element, {
			zoom: 14,
			center: center,
			disableDefaultUI: true,
		});
		const infos = [];

		markers.forEach((markerData) => {
			const markerPos = new google.maps.LatLng(markerData.location[0], markerData.location[1]);
			const markerType = markerData.type ? MARKER_TYPES[markerData.type] : MARKER_TYPES[0];
			const marker = new google.maps.Marker({
				position: markerPos,
				map: map,
				icon: markerType,
			});
			let infoContent = '';

			markerData.places.forEach((place) => {
				infoContent += `<div class="b-infobox__content">
						${place.img ? `
							<div class="b-infobox__img" style="background-image: url('${place.img}')"></div>
						` : ''}

						<div class="b-infobox__text">
							<h3 class="b-infobox__title">${place.name}</h3>

							${place.address ? `
								<p class="b-infobox__address">${place.address}</p>
							` : ''}

							${place.tel || place.email || place.web ? `
								<p class="b-infobox__contacts">
									${place.tel ? `
										<strong>${place.tel}</strong><br>
									` : ''}

									${place.email ? `
										<a href="mailto:${place.email}">${place.email}</a><br>
									` : ''}

									${place.web ? `
										<a href="${place.web}">${place.web}</a>
									` : ''}
								</p>
							` : ''}
						</div>
					</div>`;
			});

			const info = new InfoBox({
				content: `<div class="b-infobox">
						<div class="b-infobox__inner">
							${infoContent}
							<a href="#" class="b-infobox__close">
								${iconSVG('close')}
								<span class="vhide">Zavřít</span>
							</a>
						</div>
					</div>`,
				pixelOffset: new google.maps.Size(50, -75),
				infoBoxClearance: new google.maps.Size(20, 20),
				closeBoxURL: `${BASE_PATH}img/bg/close.gif`,
			});

			infos.push(info);

			marker.addListener('click', () => {
				infos.forEach((item) => item.close());

				info.open(map, marker);
			});
			bounds.extend(markerPos);
		});

		map.fitBounds(bounds);
	};

	const onLoad = () => elements.forEach(initMap);

	loadScript(SCRIPT_URL, onLoad);
};



// WEBPACK FOOTER //
// ./src/js/components/gmap.js